import { snapdom } from "@zumer/snapdom";

const FALLBACK_PIXEL_RATIO = 1;


export async function captureDomScreenshot(target, { pixelRatio = FALLBACK_PIXEL_RATIO, snapOptions } = {}) {
  if (!target || typeof target !== 'object') {
    throw new Error('A valid DOM node is required to capture a screenshot.');
  }

  const rect = target.getBoundingClientRect();
  const width = Math.round(rect.width * pixelRatio);
  const height = Math.round(rect.height * pixelRatio);

  const callOptions = {
    pixelRatio,
    backgroundColor: '#ffffff',
    ...(snapOptions || {}),
  };

  let dataUrl;

  try {
    const result = await snapdom.toPng(target, callOptions);

    if (typeof result === 'string') {
      dataUrl = result;
    } else if (result?.src) {
      dataUrl = result.src;
    } else if (typeof result?.toDataURL === 'function') {
      dataUrl = result.toDataURL('image/png');
    }
  } catch (error) {
    // continue to canvas fallback
  }

  return { dataUrl, width, height };
}
